import useFloorPlanListData from 'modules/site-walk/hooks/useFloorPlanListData';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import FloorPlanCard from '../FloorPlanCard/FloorPlanCard';
import { CircularProgress, useDialog } from '@hyperflake/react-ui-library';
import { IFloorPlanModel } from '@api/models';
import DeleteFloorPlanDrawer from '../DeleteFloorPlanDrawer/DeleteFloorPlanDrawer';
import { EmptyDataView } from 'modules/shared/features/content';

const FloorPlanList = () => {
    const { clientId, projectId } = useParams();

    const deleteFloorPlanDialog = useDialog<IFloorPlanModel>(null);

    const navigate = useNavigate();

    const { floorPlans, isLoading, handleDelete } = useFloorPlanListData({ clientId, projectId });

    if (isLoading)
        return (
            <div className="mt-6 flex justify-center items-center min-h-[600px]">
                <CircularProgress />
            </div>
        );

    return (
        <>
            <div className="grid grid-cols-12 gap-6 mt-6 empty:hidden">
                {floorPlans.map((row) => (
                    <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3" key={row._id}>
                        <FloorPlanCard
                            floorPlan={row}
                            onDeleteClick={(floorPlan) => deleteFloorPlanDialog.show(floorPlan)}
                            onEditClick={() =>
                                navigate(`/clients/${clientId}/projects/${projectId}/floor-plan/${row._id}`)
                            }
                        />
                    </div>
                ))}
            </div>
            {floorPlans.length === 0 && <EmptyDataView message="No Floor Plan Found" />}

            <DeleteFloorPlanDrawer
                floorPan={deleteFloorPlanDialog.data}
                open={deleteFloorPlanDialog.isOpen}
                onClose={deleteFloorPlanDialog.hide}
                onDelete={handleDelete}
            />
        </>
    );
};

export default FloorPlanList;
